import {afterNextRender, Component, inject, signal, ViewChild} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {filter} from 'rxjs';
import {ScreenLoaderComponent} from './components/screen-loader/screen-loader.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { en_US, NzI18nService } from 'ng-zorro-antd/i18n';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'glacies-admin';
  @ViewChild('loader') loader?: ScreenLoaderComponent;

  private _router = inject(Router);
  private readonly i18n = inject(NzI18nService);
  loadingText = signal('Application Loading');

  constructor(private translate: TranslateService) {
    
    this.i18n.setLocale(en_US);
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    afterNextRender(() => {
      // Scroll a page to top if url changed
      this._router.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          window.scrollTo({
            top: 0,
            left: 0
          });
          setTimeout(() => {
            this.loader?.hide();
          }, 3000);
        });
    });
  }
}
